import { useContext } from "react";
import { useSelector } from "react-redux";
import FactoryContext from "../contexts/factoryContext";
import { getCurrentUser } from "../store/slices/auth";

export default function useCurrentUser() {
  const factory = useContext(FactoryContext);
  const currentUserObj = useSelector(getCurrentUser);

  return factory.makeUser(currentUserObj);
}
